import { MrbBaseRouteStore } from "mrb/core";
import { LoadioContentProfileService } from "common/services";

class LoadioContentProfileListRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);
        this.contentProfileService = rootStore.createApplicationService(LoadioContentProfileService);
    }

    async findProfiles(params) {
        const response = await this.contentProfileService.find(params);
        return response.data;
    }

    async getDeviceCount(id) {
        const response = await this.contentProfileService.getDeviceCount(id);
        return response.data;
    }

    async deleteProfile(resource) {
        const response = await this.contentProfileService.delete(resource);
        return response.data;
    }
}

export default LoadioContentProfileListRouteStore;
